$('form.complete-form .submit-form').click(function (e) {
    let form = $(this).closest('form');
    let formId = form[0].id;

    let completeAssessmentModal = $('#complete-assessment-modal');

    completeAssessmentModal.attr('data-assessment-id', formId);
    completeAssessmentModal.modal('show');
    return false;
});

$('form.lock-form .submit-form').click(function (e) {
    let form = $(this).closest('form');
    let formId = form[0].id;

    let lockAssessmentModal = $('#lock-assessment-modal');

    lockAssessmentModal.attr('data-assessment-id', formId);
    lockAssessmentModal.modal('show');
    return false;
});

$('#complete-assessment-modal #submit-modal').click(function () {
    let formId = $(this).closest('#complete-assessment-modal').data('assessment-id');
    let form = document.getElementById(formId);
    form.submit();
});

$('#lock-assessment-modal #submit-modal').click(function () {
    let formId = $(this).closest('#lock-assessment-modal').data('assessment-id');
    let form = document.getElementById(formId);
    form.submit();
});
$('form.reopen-form .submit-form').click(function (e) {
    let form = $(this).closest('form');
    let formId = form[0].id;

    let reopenAssessmentModal = $('#reopen-assessment-modal');

    reopenAssessmentModal.attr('data-assessment-id', formId);
    reopenAssessmentModal.modal('show');
    return false;
});

$('#reopen-assessment-modal #submit-modal').click(function () {
    let formId = $(this).closest('#reopen-assessment-modal').data('assessment-id');
    let form = document.getElementById(formId);
    form.submit();
});

// Worklist generation

$('a.print-worklist').click(function(event) {
    event.preventDefault();
    let printWorklistModal = $('#print-worklist-modal');
    printWorklistModal.attr('data-url',  $(this).data('href'));
    printWorklistModal.modal('show');
});
$('a.print-medman-worklist').click(function(event) {
    event.preventDefault();
    let printWorklistModal = $('#print-medman-worklist-modal');
    printWorklistModal.attr('data-url',  $(this).data('href'));
    printWorklistModal.modal('show');
});
$('a.print-assessment').click(function(event) {
    event.preventDefault();
    let printAssessmentModal = $('#print-assessment-modal');
    printAssessmentModal.attr('data-url',  $(this).data('href'));
    printAssessmentModal.modal('show');
});

// Name Edit generation

$('a.name_edit_btn').click(function(event) {
    event.preventDefault();
    let editNameModal = $('#edit-name-modal');
    editNameModal.attr('data-url',  $(this).data('href'));
    editNameModal.find('#edit-name-input').val($(this).data('name'));
    editNameModal.find('#edit-name-form').attr('action',$(this).data('href'));
    editNameModal.modal('show');
});

$('#edit-name-modal #submit-modal').click(function () {
    let form = document.getElementById("edit-name-form");
    form.submit();
});

$('a.print-assessment').click(function(event) {
    event.preventDefault();
    let printAssessmentModal = $('#print-assessment-modal');
    printAssessmentModal.attr('data-url',  $(this).data('href'));
    printAssessmentModal.modal('show');
});

$('a.baa-disclaimer').click(function(event) {
    event.preventDefault();
    let baaDisclaimerModal = $('#baa-disclaimer-modal');
    baaDisclaimerModal.modal('show');
});

$('a.upload-baa-renew-btn').click(function(event) {
    event.preventDefault();
    let baaRenewModal = $('#baa-renewal-modal');
    $('#renewal-modal-renew').attr('action',  $(this).data('renew-url'));
    $('#renewal-modal-create').attr('href',  $(this).data('create-url'));

    baaRenewModal.modal('show');
});


$('a.baa-attestation-btn').click(function() {
    event.preventDefault();
    let attestationModal = $('#attestation-modal');
    attestationModal.attr('data-url', event.target.href);
    attestationModal.find('form').attr('action', event.target.href);
    attestationModal.modal('show');
});
$('a.approve-policy-btn').click(function() {
    event.preventDefault();
    let approvePolicyModal = $('#approve-policy-modal');
    approvePolicyModal.attr('data-url', event.target.href);
    approvePolicyModal.find('form').attr('action', event.target.href);
    approvePolicyModal.modal('show');
});


$('section .see-more').click(function(event) {
    event.preventDefault();
    $(this).closest('section').toggleClass('collapsed');
});

// $('#print-worklist-modal #submit-modal').click(function () {
//     let url = $(this).closest('#print-worklist-modal').data('url');
//     window.open(url, '_blank');
//     $(this).closest('#print-worklist-modal').modal('hide');
// });

$('#attestation-modal #submit-modal').click(function () {
    $('#attestation-modal form').submit();
});

$('#approve-policy-modal #submit-modal').click(function () {
    $('#approve-policy-modal form').submit();
    $(this).closest('#print-worklist-modal').modal('hide');
});

$('.show-archived-policies').click(function () {
    $.ajax({
        type: 'GET',
        url: '/toggle-policy-archives',
        processData: false,
        contentType: 'application/json',
        success : function(response, textStatus, jqXhr) {
            $('.dashboard-container').toggleClass('show-policy-archives');
        },
    });
});

$('#affiliate_filter').click(function () {
    $('#filterform').attr('action', $('#affiliate_filter').attr('data-url')).submit();
});



$('.policy-archive-toggle').change(function(event) {
    let self = this;
    let checked = 0;

    let token = $('meta[name="csrf-token"]').val();
    let policy = $(this).data('policy');
    let url = $(this).data('url');
    if ($(this).is(':checked')) {
        checked = 1;
    }


    $.ajax({
        type: 'GET',
        url: url + '/' + checked,
        processData: false,
        contentType: 'application/json',
        success : function(response, textStatus, jqXhr) {
            $(self).closest('.card').toggleClass('policy-archived');
        },
        error : function(jqXHR, textStatus, errorThrown) {
            if(checked){
                $(self).prop("checked", false);
            }else{
                $(self).prop("checked", true);
            }
        },
    });

});

$('.disable-privacy-toggle').change(function(event) {
    let self = this;
    let checked = 1;

    let token = $('meta[name="csrf-token"]').val();
    let assessment = $(this).data('assessment');
    let url = $(this).data('url');
    if ($(this).is(':checked')) {
        checked = 0;
    }


    if(checked){
        $(self).prop("checked", false);
    }else{
        $(self).prop("checked", true);
    }
    $.ajax({
        type: 'GET',
        url: url + '/' + checked,
        processData: false,
        contentType: 'application/json',
        success : function(response, textStatus, jqXhr) {
            location.reload();
        },
        error : function(jqXHR, textStatus, errorThrown) {
            if(checked){
                $(self).prop("checked", true);
            }else{
                $(self).prop("checked", false);
            }
        },
    });

});

$('#print-worklist-modal #submit-with-modal').click(function () {
    let url = $(this).closest('#print-worklist-modal').attr('data-url');
    let type = $('#worklist_type').val();

    let original_btn = $('a.print-worklist[data-href="' + url + '"]').get(0);

    url = url.slice(0, -4)

    if(type == 'XLS'){
        url = url.replace('/pdf','/xls')
    }

    if($("input[name='worklist-full']:checked").val() == 1){
        url = url + '/remaining';
    }

    url = url + '/' + $("select[name='worklist_sort']").val();
    url = url + '/' + $("input[name='worklist_safeguard']:checked").val();

    if($("input[name='worklist-comments']:checked").val() == 1){
        url = url + '/1';
    }
    // window.open(url, '_blank');
    generatePdf(original_btn, url);
    $(this).closest('#print-worklist-modal').modal('hide');
});

$('#print-medman-worklist-modal #medman-submit-with-modal').click(function () {
    let url = $(this).closest('#print-medman-worklist-modal').attr('data-url');
    let type = $('#medman_worklist_type').val();

    let original_btn = $('a.print-medman-worklist[data-href="' + url + '"]').get(0);

    url = url.slice(0, -4)

    if(type == 'XLS'){
        url = url.replace('/pdf','/xls')
    }

    if($("input[name='medman-worklist-full']:checked").val() == 1){
        url = url + '/remaining';
    }

    url = url + '/' + $("select#medman_worklist_sort").val();
    url = url + '/1';

    if($("input[name='medman-worklist-comments']:checked").val() == 1){
        url = url + '/1';
    }
    // window.open(url, '_blank');
    generatePdf(original_btn, url);
    $(this).closest('#print-medman-worklist-modal').modal('hide');
});

$('#print-assessment-modal #submit-with-modal').click(function () {
    let url = $(this).closest('#print-assessment-modal').attr('data-url');
    let original_btn = $('a.print-assessment[data-href="' + url + '"]').get(0);

    url = url + '/' + $("select[name='assessment_sort']").val();
    let type = $('#assessment_type').val();

    if(type == 'XLS'){
        url = url.replace('/pdf','/xls')
    }
    if($("input[name='assessment-comments']:checked").val() == 1){
        url = url + '/1';
    }

    generatePdf(original_btn, url);
    $(this).closest('#print-assessment-modal').modal('hide');
});


function updatePlanForm(){
    $('#plan_form button').attr('disabled', $('.form-control:checked').length == 0);
}

function updateMedManForm(){
    $('.section_wrap').show();
    $('#medman_form input.form-control:checked').each(function(){
        if($(this).attr('name') == 'bundle[]'){
            let sections = $(this).data('sections').split(',');
            for (index = 0; index < sections.length; index++) {
                $('#section_wrap_'+sections[index]).hide()
            }
        }
    });

    if($(".section_wrap:visible").length){
        $("#sectionsAllTaken").hide();
    }else{
        $("#sectionsAllTaken").show(500);
    }
    $('#medman_form .plan-submit').attr('disabled', $('#medman_form input.form-control:checked').length == 0);
}

function generatePdf(linkref, href){
    let html = $(linkref).html();

    $(linkref).removeClass('generating-pdf-error');
    $(linkref).addClass('generating-pdf');
    $(linkref).attr('disabled', 'disabled');
    $(linkref).html('Generating <i class="fas fa-spinner fa-spin"></i>');
    let filename = $(linkref).attr('data-filename');
    $(linkref).removeAttr('href');

    $.ajax({
        url: href,
        success: function(data) {
            window.open(data);

            $(linkref).removeAttr('disabled');
            $(linkref).removeClass('generating-pdf');
            $(linkref).attr('href', href);
            $(linkref).html(html);
        },
        error: function(data) {
            $(linkref).removeAttr('disabled');
            $(linkref).addClass('generating-pdf-error');
            $(linkref).attr('href', href);
            $(linkref).html(html);
        },
    });
}

$(function() {

    $('.print-worklist').show();
    $('.print-medman-worklist').show();
    $('.print-assessment').show();
    $('.pdf_gen').show();
    $('.pdf_gen').click(function(e){
        e.preventDefault();
        generatePdf(this, $(this).data('href'))
    });


    $('#plan_form button').attr("disabled",true);

    updatePlanForm();

    $('#plan_form').change(function() {
        updatePlanForm();
    });
    updateMedManForm();

    $('#medman_form').change(function() {
        updateMedManForm();
    });

    $("input[name='card']").change(function(){
        updateCardList();
    });
    $(".is-demo").click(function(e){
        e.preventDefault();
        let demo = 1;
        if($(this).hasClass('locked')){
            demo = 0;
        }
        $.post('/toggle-demo', {'demo' : demo, '_token' : $(this).data('token')},
            function (data, status) {
                location.reload();
            }
        );
    });

});

function updateCardList(){
    if($("input[name='card']:checked").val() == '0'){
        $('#card-info').show();
    }else{

        $('#card-info').hide();
    }
}
